import React from "react";
import { EMPTY_STRING } from "../../../constants";
import CustomTooltip from "../ToolTip/CustomTooltip";

const SquareImageSelection = ({
  checkBoxId,
  src,
  url,
  type,
  selected,
  setSelected,
  data,
  id,
  disabled = false,
  showTooltip = false,
  setMediaUrl,
  setIsModalOpen,
  ...props
}) => {
  const isVideo = (url) => {
    if (!url) return false;
    const videoExtensions = [
      ".mp4",
      ".webm",
      ".ogg",
      ".avi",
      ".mov",
      ".wmv",
      ".flv",
      ".mkv",
    ];
    return videoExtensions.some((ext) => url.toLowerCase().includes(ext));
  };

  const renderMedia = () =>
    !src ? (
      <img src="/images/accountSelectionImage.png" alt="" />
    ) : isVideo(src) ? (
      <video
        src={process.env.REACT_APP_S3_BASE_URL_EVENTS_GALLERY + "/" + src}
        muted
        loop
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    ) : (
      <img
        src={process.env.REACT_APP_S3_BASE_URL_EVENTS_GALLERY + "/" + src}
        alt=""
      />
    );

  const content = (
    <div className="text-center">
      <div
        className={`profile-img-con ${selected && "selected-image"} ${
          disabled ? "disabled-image" : EMPTY_STRING
        }`}
        {...props}
      >
        {renderMedia()}
        <input
          type="checkbox"
          className="check cursor-pointer"
          id={checkBoxId}
          onClick={() => !disabled && setSelected(id)}
          checked={selected}
          disabled={disabled}
        />
        <label htmlFor={checkBoxId}></label>
      </div>
      <button
        type="button"
        className="recap-button"
        onClick={(e) => {
          e.preventDefault();
          setMediaUrl(url + `?timestamp=${Date.now()}`);
          setIsModalOpen(true);
        }}
      >
        {type}
      </button>
    </div>
  );

  return showTooltip ? (
    <CustomTooltip
      title="Feedback is already submitted"
      arrow
      placement="right"
    >
      <span tabIndex="0">{content}</span>
    </CustomTooltip>
  ) : (
    content
  );
};

export default SquareImageSelection;
